module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBRAPCjjWEN/vAAAAYUlEQVQ4y2NgQAAnhqcMfQyMDESDUob/DP8Z5hKvhYfhMMN/hv8Mc0jXMpsuWmbRRctM0rXMoIuW6aRrSUIIMRGrlwZOItHTZConMuJITBpkKicyeZOpnOgsSnIhQFQxAwCPGkoImW+LtAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wNS0xNlQxNToxMDo1NiswMjowMOkQKKIAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTgtMDUtMTZUMTU6MTA6NTYrMDI6MDCYTZAeAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./scripts/src/assets/icons/black/next1.png
// module id = 296
// module chunks = 0